import { Link } from '@tanstack/react-router'

import { MAIN_NAV } from '@/config/navigation'

/**
 * Horizontal primary navigation. Active and inactive colors are supplied via
 * mutually-exclusive `activeProps`/`inactiveProps` so the two never conflict.
 */
export function MainNav() {
  return (
    <nav className="hidden items-center gap-0.5 md:flex">
      {MAIN_NAV.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
          activeProps={{ className: 'text-foreground' }}
          inactiveProps={{ className: 'text-muted-foreground hover:text-foreground' }}
          activeOptions={{ exact: item.to === '/' }}
        >
          {item.label}
        </Link>
      ))}
    </nav>
  )
}
